module.exports = __webpack_public_path__ + "static/media/give-facebook.39046fe8.svg";